import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'help',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/HelpLandingPageContainer'),
  }),
};
